import { Edit, Visibility } from "@mui/icons-material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton, List, ListItem, Tooltip } from "@mui/material";

export interface MessageTemplateTableActionsProps {
  id: string;
  onDeleteClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onEditClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onPreviewClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  onDuplicateClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export default function MessageTemplateTableActions({
  id,
  onDeleteClick,
  onEditClick,
  onPreviewClick,
  onDuplicateClick,
}: MessageTemplateTableActionsProps) {
  return (
    <List
      aria-label="Template Quick Actions"
      sx={{
        padding: 0,
        display: "flex",
        justifyContent: "flex-start",
        gap: "1ch",
        "& .MuiListItem-root": {
          width: "auto",
          padding: 0,
          borderRadius: "50%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: "0.875rem",
        },
        "& .MuiIconButton-root": {
          border: "2px solid rgba(0,0,0,0.3)",
        },
      }}
    >
      {onEditClick !== undefined && (
        <Tooltip title={"Edit"}>
          <ListItem
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <IconButton aria-label={"Edit"} onClick={onEditClick} data-test={`edit-template-${id}`}>
              <Edit sx={{ fontSize: "1rem" }} />
            </IconButton>
          </ListItem>
        </Tooltip>
      )}
      {onDeleteClick !== undefined && (
        <Tooltip title={"Delete"}>
          <ListItem
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <IconButton aria-label={"Delete"} onClick={onDeleteClick} data-test={`delete-template-${id}`}>
              <DeleteIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </ListItem>
        </Tooltip>
      )}
      {onPreviewClick !== undefined && (
        <Tooltip title="Preview">
          <ListItem
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <IconButton aria-label="Preview" onClick={onPreviewClick} data-test={`preview-template-${id}`}>
              <Visibility sx={{ fontSize: "1rem" }} />
            </IconButton>
          </ListItem>
        </Tooltip>
      )}
      {onDuplicateClick !== undefined && (
        <Tooltip title={"Duplicate"}>
          <ListItem
            onClick={(event) => {
              event.stopPropagation();
            }}
          >
            <IconButton
              aria-label={"Duplicate"}
              onClick={onDuplicateClick}
              data-test={`duplicate-template-${id}`}
            >
              <ContentCopyIcon sx={{ fontSize: "1rem" }} />
            </IconButton>
          </ListItem>
        </Tooltip>
      )}
    </List>
  );
}
